import type { CompleteStoreFragment } from '@drycut/graphql';

import { StoreWaitingTime } from '@drycut/controlled-components';
import { Heading, Para } from '@drycut/ui-components';
import { MAX_MINUTES_TO_DISPLAY } from '@drycut/ui-format-utils';

import StylistList from './StylistList';

type Props = {
  store: CompleteStoreFragment;
};

export default function StepWaitingTime({ store }: Props): React.ReactElement {
  const longerWait = store.waitingTime > MAX_MINUTES_TO_DISPLAY * 60;

  return (
    <>
      {!longerWait ? (
        <Para>Buche jetzt den nächsten verfügbaren Slot in</Para>
      ) : (
        <Para className="text-xl lg:text-base">Nächster freier Termin</Para>
      )}

      <Heading variant="h3" className="mb-2">
        <StoreWaitingTime store={store} showCa showZero steps />
        {!longerWait && <StylistList stylists={store.checkedInStylists} />}
      </Heading>
    </>
  );
}
